import React, { useState } from 'react';
import './styles.css';
function FlightPassengerManagement({ value, onChange, finishProcess }) {
    const [error, setError] = useState('');
    function assessCounter(type, operationSuma) {
        const { adult, boy, baby } = value || {};
        const totalPassengers = adult + boy + baby;
        const maxPassengers = 9
        const isError = error !== '';
        const errorMessages = {
            error1: "Puedes hacer reserva hasta un máximo de 9 pasajeros.",
            error2: "El número de adultos debe ser igual al número de bebés. (0 a 23 meses)",
            error3: "Por cada adulto solo pueden viajar 2 menores de edad. (2 a 11 años)"
        };
        if (!operationSuma) {
            //minimo adulto
            if (type === 'adult' && value[type] === 1) return false;
            //minimo boy y baby
            if ((type === 'boy' || type === 'baby') && value[type] === 0) return false;
        }
        if (operationSuma) {
            if (totalPassengers === maxPassengers) {
                setError(errorMessages.error1);
                return;
            }
            if (type === 'boy' && adult * 2 === boy) {
                setError(errorMessages.error3);
                return;
            }

            if (type === 'baby' && adult === baby) {
                setError(errorMessages.error2);
                return;
            }
        }
        if (isError && ((type === 'baby' && value[type] <= adult) || (type === 'boy' && value[type] <= adult * 2))) {
            setError('');
            onChange(type, operationSuma);
        }
        onChange(type, operationSuma);
    }

    return (
        <div className='flightPassengerManagement'>
            <p className='flightPassengerManagementTitle'>pasajeros</p>
            <p className='flightPassengerManagementError'>{error}</p>
            <div className='flightPassengerManagementGroup'>
                <div className='flightPassengerManagementGroupLeft'>
                    <p className='flightPassengerManagementGroupName'>Adultos</p>
                    <p className='flightPassengerManagementGroupdescription'></p>
                </div>
                <div className='flightPassengerManagementGroupRigth'>
                    <div className='flightPassengerManagementGroupRigthBtn' onClick={() => assessCounter('adult', false)}>
                        <p className='flightPassengerManagementGroupRigthBtnText'>-</p>
                    </div>
                    <p className='flightPassengerManagementGroupRigthValue'>{value?.adult}</p>
                    <div className='flightPassengerManagementGroupRigthBtn' onClick={() => assessCounter('adult', true)}>
                        <p className='flightPassengerManagementGroupRigthBtnText'>+</p>
                    </div>
                </div>
            </div>
            <div className='flightPassengerManagementGroup'>
                <div className='flightPassengerManagementGroupLeft'>
                    <p className='flightPassengerManagementGroupName'>Niños</p>
                    <p className='flightPassengerManagementGroupdescription'>2 A 11 Años</p>
                </div>
                <div className='flightPassengerManagementGroupRigth'>
                    <div className='flightPassengerManagementGroupRigthBtn' onClick={() => assessCounter('boy', false)}>
                        <p className='flightPassengerManagementGroupRigthBtnText'>-</p>
                    </div>
                    <p className='flightPassengerManagementGroupRigthValue'>{value?.boy}</p>
                    <div className='flightPassengerManagementGroupRigthBtn' onClick={() => assessCounter('boy', true)}>
                        <p className='flightPassengerManagementGroupRigthBtnText'>+</p>
                    </div>
                </div>
            </div>
            <div className='flightPassengerManagementGroup'>
                <div className='flightPassengerManagementGroupLeft'>
                    <p className='flightPassengerManagementGroupName'>Bebés</p>
                    <p className='flightPassengerManagementGroupdescription'>0 A 23 Meses</p>
                </div>
                <div className='flightPassengerManagementGroupRigth'>
                    <div className='flightPassengerManagementGroupRigthBtn' onClick={() => assessCounter('baby', false)}>
                        <p className='flightPassengerManagementGroupRigthBtnText'>-</p>
                    </div>
                    <p className='flightPassengerManagementGroupRigthValue'>{value?.baby}</p>
                    <div className='flightPassengerManagementGroupRigthBtn' onClick={() => assessCounter('baby', true)}>
                        <p className='flightPassengerManagementGroupRigthBtnText'>+</p>
                    </div>
                </div>
            </div>
            <div className='flightPassengerManagementBtn' onClick={()=>finishProcess()}>
                <p className='flightPassengerManagementBtnText'>continuar</p>
            </div>
        </div>
    )
}

export default FlightPassengerManagement